"use client";

export const MedriteLoader = ({ className }: { className?: string }) => {
  return (
    <object
      id="medrite-loader"
      data="/images/kiosk/medrite_loader1.svg"
      type="image/svg+xml"
      width="350"
      height="350"
      aria-label="Loading spinner"
      className={className}
    />
  );
};
